module.exports = __webpack_public_path__ + "img/link-icon.ab09ec45.svg";